<template>
	<AppLazyLoaderComponentFromMonolith
		class="project-tab-details"
		:params="params"
		:container="Monolith.LAZY_CONTAINER.DETAILS"
		@response="onResponse"
	/>
</template>

<script lang="ts" setup>
import { computed, nextTick, watch, onMounted, onBeforeUnmount } from 'vue';
import { Monolith } from '@/constants/monolith';
import { AppLazyLoaderComponentFromMonolith } from '@/features/App';
import { useMfeUtils } from '@/composables';
import { type Project, TabKey } from '@/generated/graphql';
import { useRoute } from 'vue-router';
import {
	ProjectModifyTabs,
	useProjectModifyModalStore,
	PROJECT_TABS,
} from '@/features/Project';

const detailsLink = PROJECT_TABS[TabKey.Details].link;

const { rootEmit } = useMfeUtils();
const onResponse = async (payload: { isEmpty: boolean }) => {
	if (!payload.isEmpty) {
		await nextTick();

		rootEmit('init-monolith-selectors', {
			baseSelector: '.project-tab-details',
		});
	}
};

const route = useRoute();

watch(
	() => route.path,
	() => {
		if (detailsLink && route.path.endsWith(detailsLink)) {
			rootEmit('init-tinymce', {
				baseSelector: '.project-tab-details',
			});
		}
	}
);

const props = defineProps<{
	projectId: Project['id'];
}>();

const params = computed(() => ({
	project_id: String(props.projectId),
}));

const projectModalStore = useProjectModifyModalStore();

const handleDocumentClick = (event: MouseEvent) => {
	const target = event.target;

	if (
		!(target instanceof HTMLElement) ||
		!target.classList.contains('js-open-project-modal')
	) {
		return;
	}

	event.preventDefault();

	const cfName = target.dataset.cfName;
	const cfValue = target.dataset.cfValue;

	let customFields = {};
	if (cfName !== undefined && cfValue !== undefined) {
		customFields = {
			[cfName]: cfValue,
		};
	}

	projectModalStore.open({
		projectId: undefined,
		tab: ProjectModifyTabs.GENERAL,
		initialCustomFields: customFields,
	});
};

onMounted(() => {
	document.addEventListener('click', handleDocumentClick);
});

onBeforeUnmount(() => {
	document.removeEventListener('click', handleDocumentClick);
});
</script>

<style lang="scss">
.project-tab-details {
	.pr-info {
		max-height: none !important;
		overflow: visible !important;
	}

	.pr-edit {
		&__save {
			border: 0;
		}
	}

	.project-description-content-block .showMore {
		display: none !important;
	}
}
</style>
